/**
 * File d'attente globale d'enregistrement automatique.
 * Rejoue toutes les modifications en attente (clés localStorage « vd-autosave::<url> »)
 * au démarrage et au retour du réseau, sans exiger de revenir sur le formulaire d'origine.
 */
import client from './api';

const PREFIX = 'vd-autosave::';
let draining = false;

export async function drainAutoSaveQueues() {
  if (draining || (typeof navigator !== 'undefined' && navigator.onLine === false)) return;
  draining = true;
  try {
    const keys = Object.keys(localStorage).filter((k) => k.startsWith(PREFIX));
    for (const key of keys) {
      const url = key.slice(PREFIX.length);
      let payload;
      try { payload = JSON.parse(localStorage.getItem(key)); } catch { localStorage.removeItem(key); continue; }
      if (!payload || !Object.keys(payload).length) { localStorage.removeItem(key); continue; }
      try {
        await client.patch(url, payload);
        localStorage.removeItem(key);
      } catch (err) {
        if (err.code === 422 || err.code === 409) localStorage.removeItem(key); // ne pas boucler sur un refus
        else break; // réseau/serveur : on réessaiera plus tard
      }
    }
  } finally { draining = false; }
}

/** Installe l'auto-vidage (démarrage + retour réseau). À appeler une fois. */
export function installAutoSaveDrain() {
  const run = () => drainAutoSaveQueues();
  window.addEventListener('online', run);
  setTimeout(run, 1500); // léger différé pour laisser l'auth se faire
  return () => window.removeEventListener('online', run);
}
